import { render, staticRenderFns } from "./SwayOfferWebGiveAwayCard.vue?vue&type=template&id=4d9b0d62&scoped=true&"
import script from "./SwayOfferWebGiveAwayCard.vue?vue&type=script&lang=js&"
export * from "./SwayOfferWebGiveAwayCard.vue?vue&type=script&lang=js&"
import style0 from "./SwayOfferWebGiveAwayCard.vue?vue&type=style&index=0&id=4d9b0d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9b0d62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
